import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/save_search"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73118 2.04499C6.4063 1.45329 5.80187 1 5 1C4.29341 1 3.75 1.48 3.5 1.96C3.25 1.48 2.70576 1 2 1C0.766353 1 0 2.0729 0 3.07206C0 4.04695 0.794718 4.99246 1.62686 5.71144C1.66004 5.74011 1.69328 5.76842 1.72653 5.79635C2.35166 6.32155 2.98086 6.71504 3.29512 6.89378C3.4168 6.96299 3.49127 7 3.5 7C3.5522 7 5.95223 5.6779 6.74722 4.06269C6.75644 4.04396 6.76544 4.02519 6.77422 4.00639C6.91608 3.70256 7 3.38886 7 3.07206C7 3.04084 6.99925 3.00954 6.99776 2.97821C6.98259 2.65861 6.8905 2.33516 6.73118 2.04499ZM1.03739 7.79869C1.01268 8.02907 1 8.26306 1 8.5C1 12.0898 3.91015 15 7.5 15C9.16986 15 10.6926 14.3703 11.8439 13.3354L14.7288 15.9269L16.0653 14.4391L13.1103 11.7846C13.6758 10.8208 14 9.69824 14 8.5C14 5.3864 11.8108 2.78412 8.88766 2.14845C8.96214 2.4585 9 2.77008 9 3.07206C9 3.47408 8.93685 3.85182 8.83409 4.20104C10.668 4.76953 12 6.47921 12 8.5C12 10.9853 9.98528 13 7.5 13C5.1639 13 3.24357 11.2199 3.02144 8.94213L3.00119 8.93699L2.99922 8.93648C2.921 8.91634 2.85972 8.89549 2.82667 8.88378C2.75904 8.85981 2.70596 8.83695 2.68113 8.82606C2.62627 8.802 2.57923 8.77875 2.55062 8.76434C2.4878 8.7327 2.42073 8.69647 2.3553 8.65988C2.22105 8.58478 2.05015 8.48369 1.85599 8.36062C1.62084 8.21157 1.33898 8.02232 1.03739 7.79869Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { SaveSearch16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var SaveSearch16 = createIcon(IconComponent);